import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CPUBenchmarkItem } from '@models/domain/cpu.benchmark.item';
import { AddCPUBenchmarkRequest } from '@models/ss-api/requests/add.cpu.benchmark.request';
import { UpdateCPUBenchmarkRequest } from '@models/ss-api/requests/update.cpu.benchmark.request';
import { GlobalMACWhitelistBasic } from '@models/ss-api/responses/global.mac.whitelist.basic';

export interface IAddGlobalMACWhitelist {
    Title: string;
}

@Component({
    selector: 'add-global-mac-whitelist-dialog',
    styleUrls: ['./add.global.mac.whitelist.dialog.scss'],
    templateUrl: './add.global.mac.whitelist.dialog.html'
})

export class AddGlobalMACWhitelist extends DialogComponent<IAddGlobalMACWhitelist, boolean> implements IAddGlobalMACWhitelist, OnInit {
    IsBusy: boolean;
    Title: string;
    GlobalMACWhitelistBasic: GlobalMACWhitelistBasic;

    GlobalMACWhitelistForm: FormGroup;

    constructor(private api: ssApiService, dialogService: DialogService, private gb: GlobalService, private sweetAlert: SweetAlertService, public router: Router) {
        super(dialogService, router);
    }

    ngOnInit() {
        this.IsBusy = false;
        if (!this.GlobalMACWhitelistBasic) {
            this.GlobalMACWhitelistBasic = new GlobalMACWhitelistBasic();
        } else {

        }

        this.GlobalMACWhitelistForm = new FormGroup({
            'MACAddress': new FormControl(this.GlobalMACWhitelistBasic.MACAddress, [Validators.required])
        })
    }

    confirm() {
        console.log("val", this.GlobalMACWhitelistForm.valid);
        if (!this.GlobalMACWhitelistForm.valid) return false;
        this.IsBusy = true;
        this.result = true;

        let controls = this.GlobalMACWhitelistForm.controls;
        let disposable = this.api.AddGlobalMACWhitelist(controls['MACAddress'].value).subscribe(response => {
            if (response.Result) {
                this.sweetAlert.swal({
                    type: 'success',
                    title: 'Success!',
                    timer: 1500
                }).then( () => { this.close(); }, () => { this.close(); } )
            }
            disposable.unsubscribe();
        })
    }

}
